import React from 'react';
import { forTemplate } from 'app/common/lib/util/i18n';
import { Button } from '@trello/nachos';
import { track } from '@trello/analytics';

import styles from './SelectCoverEmpty.less';

const format = forTemplate('card_cover_chooser');

interface SelectCoverEmptyProps {
  navigateToAddCover: () => void;
}

export const SelectCoverEmpty: React.FunctionComponent<
  SelectCoverEmptyProps
> = ({ navigateToAddCover }) => (
  <div>
    <div className={styles.emptyText}>{format('you-dont-have-any-covers')}</div>
    <Button
      className={styles.addCoverButton}
      appearance="primary"
      shouldFitContainer
      onClick={() => {
        track('Card Cover Chooser', 'Navigated', 'Empty State');
        navigateToAddCover();
      }}
    >
      {format('add-a-cover')}
    </Button>
  </div>
);
